// extracted by mini-css-extract-plugin
export default {"rating":"tH-z","numberOfStars":"uH-z","count":"vH-z","barGraphSpacing":"wH-z","barGraph":"xH-z"};